/* eslint-disable no-unused-vars */
<template>
    <div>
        <div class="w-full">
            <form @submit.prevent="handleSubmit" v-show="showSearch">
                <div class="pt-1">
                    <div class="flex flex-row bg-white w-full">
                        <div class="w-1/3 py-3 pr-2" :class="{ invalid: $v.search.state.$error }">
                            <label>State</label>
                            <select name="state" id="state" class="form-select block w-full" v-model="search.state">
                                <option value>States</option>
                                <option v-for="state in states" :key="state.abbreviation" :value="state.abbreviation">
                                    {{ state.name }}
                                </option>
                            </select>
                        </div>

                        <div class="w-1/3 py-3 pr-2">
                            <label>Institution Type</label>
                            <select name="type" id="type" class="form-select block w-full" v-model="search.type">
                                <option value>Institution types</option>
                                <option v-for="type in types" :key="type.abbreviation" :value="type.abbreviation">
                                    {{ type.name }}
                                </option>
                            </select>
                        </div>

                        <div class="w-1/3 py-3" :class="{ invalid: $v.search.name.$error }">
                            <label for="name">Institution Quick Search</label>
                            <input
                                type="text"
                                id="name"
                                class="form-input block w-full search"
                                v-model="search.name"
                                placeholder="Institution Quick Search"
                            />
                        </div>
                    </div>

                    <div class="flex flex-row content-end bg-white w-full px-3 pb-2 pt-2">
                        <div class="w-2/3">&nbsp;</div>
                        <div class="w-1/3">
                            <p v-if="$v.$anyError" class="required text-left mt-2 text-sm">
                                Please fill out the required field(s). Either state or Institution Quick Search are
                                required fields.
                            </p>
                            <div class="mt-2 text-center">
                                <button class="btn btn-secondary" type="submit" @click="dialog = true">
                                    <font-awesome-icon
                                        :icon="['fal', 'search']"
                                        size="lg"
                                        class="mr-2"
                                    ></font-awesome-icon
                                    >Get Catalogs
                                </button>
                            </div>
                            <p class="text-xs text-center mt-2">
                                By using DegreeData I agree to the following
                                <a
                                    href="https://www.degreedata.com/wp-content/uploads/2018/01/2017-04-10-Website-TsCs-1.docx"
                                    >Terms and Conditions</a
                                >
                            </p>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div v-if="institutionCount > 0">
            <div class="w-full bg-white mb-6 pt-2 shadow-lg">
                <div>
                    <button
                        class="text-orange-600 cursor-pointer pl-4 hover:underline"
                        @click="showFilters"
                        v-show="!showSearch"
                    >
                        <font-awesome-icon
                            :icon="['fal', 'chevron-circle-left']"
                            size="lg"
                            class="mr-2"
                        ></font-awesome-icon>
                        Return to search
                    </button>
                </div>
                <div class="flex px-4 align-baseline">
                    <div class="w-1/3">
                        <div class="font-serif text-4xl">{{ getInstitutions[0].state | stateFormatter }}</div>
                    </div>

                    <div class="w-1/3">
                        <div class="font-serif text-5xl text-center">
                            {{ institutionCount }}
                            <span class="font-sans ml-1 text-base">colleges</span>
                        </div>
                    </div>

                    <div class="w-1/3">
                        <v-text-field
                            v-model="tableSearch"
                            label="Filter the list"
                            append-icon="search"
                            single-line
                            hide-details
                        ></v-text-field>
                    </div>
                </div>

                <div class="px-4 mb-4 text-xs text-gray-600">
                    <span class="font-bold">Why do the search results look different?</span> DegreeData makes research
                    more efficient by presenting PDF catalogs in pre-parsed sections including programs, courses and
                    general education. Not all catalogs are presented in sections however–Catalogs which are created in
                    HTML are easily navigable and don’t require parsing.
                </div>
                <template>
                    <v-data-table
                        :headers="headers"
                        :items="getInstitutions"
                        :search="tableSearch"
                        class="elevation-1 text-base font-sans"
                        item-key="name"
                        :sort-by="['name']"
                    >
                        <template v-slot:item.catalogs="{ item }">
                            <div class="dropdown-container relative">
                                <select
                                    class="block appearance-none w-full bg-gray-200 border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                    @change="onChange($event)"
                                >
                                    <option value>Please Select</option>
                                    <option
                                        v-for="catalog in item.catalogs"
                                        :key="catalog.id"
                                        :value="catalog.id"
                                        :data-linkcount="catalog.links.length"
                                        :data-linkval="catalog.links.legacy_id"
                                        :data-catalogid="catalog.id"
                                    >
                                        {{ catalog.year }} {{ catalog.catalog_type }}
                                        {{ catalog.links.media_type }}
                                    </option>
                                </select>
                                <div
                                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                                >
                                    <svg
                                        class="fill-current h-4 w-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </template>

                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning"
                                >Your search for "{{ search }}" found no results.</v-alert
                            >
                        </template>
                    </v-data-table>

                    <div class="text-xs -mt-6 px-4 text-gray-600 font-sans">
                        Search results vary depending upon media. For more information, see details.
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { required, requiredIf } from "vuelidate/lib/validators";
import { states } from "@/lists/states";
import { types } from "@/lists/types";
import { areas } from "@/lists/areas";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            showSearch: true,
            states: states,
            types: types,
            areas: areas,
            info: null,
            search: this.createFreshSearchObject(),
            tableSearch: "",
            headers: [
                {
                    text: "Institution",
                    align: "left",
                    sortable: true,
                    value: "name"
                },
                // { text: "Catalog Type", value: "catalogs[0].catalog_type" },
                {
                    text: "Archives",
                    sortable: false,
                    value: "catalogs"
                }
            ]
        };
    },

    filters: {
        stateFormatter: function(val) {
            var newVal = "";
            states.map(function(el) {
                if (val == el.abbreviation) {
                    newVal = el.name;
                }
            });
            return newVal;
        }
    },
    validations: {
        search: {
            state: {
                required: requiredIf(function(search) {
                    return search.name === "";
                })
            },
            name: {
                required: requiredIf(function(search) {
                    return search.state === "";
                })
            }
        }
    },
    computed: {
        ...mapGetters({
            institutionCount: "institutions/getInstitutionsWithCatalogsCount",
            getInstitutions: "institutions/getInstitutionsWithCatalogs",
            catalogCount: "institutions/getCatalogCount"
        })
    },

    created() {
        this.$store.dispatch("getToken");
    },
    methods: {
        handleSubmit(evt) {
            evt.preventDefault();
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.getSearchResults();
            } else {
                this.$log.error("The form failed the validation rules");
            }
        },
        showFilters() {
            this.showSearch = true;
        },

        onChange(e) {
            const theBaseURL = "http://catalogs.degreedata.com/viewer/";
            const theTarget = e.target.options[e.target.options.selectedIndex].dataset;

            window.open(theBaseURL + theTarget.linkval, "_blank");
        },

        async getSearchResults() {
            let params = "?";
            for (let [key, value] of Object.entries(this.search)) {
                params += key + "=" + value + "&";
            }

            params = params.slice(0, -1);

            try {
                await this.$store.dispatch("institutions/post", params);
                await this.$store.dispatch("institutions/fetchInstitutions", params);
                this.showSearch = false;
            } catch (ex) {
                this.$log.info(ex);
            }
        },

        createFreshSearchObject() {
            return {
                state: "",
                cip_tag: "",
                name: "",
                type: ""
            };
        }
    }
};
</script>

<style lang="css">
.v-application--wrap {
    min-height: 100% !important;
}

.v-data-footer__select {
    display: none;
}

.v-data-table__wrapper table {
    margin: 0 !important;
}

input.search {
    border-color: #e2e8f0 !important;
    border-style: solid !important;
    border-width: 1px !important;
    background-color: #fff !important;
}

.v-select__slot > input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    border-color: #e2e8f0;
    border-width: 1px;
    border-radius: 0.25rem;
    padding-top: 0.5rem;
    padding-right: 0.75rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
}

.v-text-field__slot > input {
    border-color: #fff !important;
    border-width: 0px !important;
    background-color: #fff !important;
}

.dropdown-container > select {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.25rem;
    border-width: 1px;
    background-color: #edf2f7;
    border-color: #cbd5e0;
}

table tr td,
table tr th {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-left: none !important;
    border-right: none !important;
}
</style>
